import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApiResponse, ToasterMessage } from 'app/app.types';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, ReplaySubject, takeLast, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    private _loader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _message$ = new BehaviorSubject<ToasterMessage | null>(null);
    private _errors: BehaviorSubject<HttpErrorResponse | null> = new BehaviorSubject<HttpErrorResponse | null>(null);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get message$(): Observable<ToasterMessage | null> {
        return this._message$.asObservable();
    }

    get loader$(): Observable<boolean> {
        return this._loader.asObservable();
    }

    get errors$(): Observable<HttpErrorResponse | null> {
        return this._errors.asObservable();
    }

    show_message(message: string, status: 'success' | 'error' | any) {
        this._message$.next({ message, type: (status == 'success' ? 'success' : 'error') });
    }

    clear_message() {
        this._message$.next(null);
    }

    show_loader() {
        this._loader.next(true);
    }

    hide_loader() {
        this._loader.next(false);
    }

    register_error(error: HttpErrorResponse) {
        const apiStatus = error?.error && typeof error.error === 'object'
            ? (error.error as any).status
            : undefined;

        if (apiStatus === 'alert') return;
        this._errors.next(error);
    }

    send_error(): Observable<ApiResponse> {
        const error: HttpErrorResponse | null = this._errors.getValue();
        return this._httpClient.post<ApiResponse>(
            `/api/dashboard/report`,
            error
        );
    }
}
